
<template>

<elements ref="table"
	v-if="ready == 3"
	:service="service"
	:attrs="attrs"
	style="min-height: 100%;"
	essence_name_genetive_case="модели"
	essence_name_for_plural_1="модель"
	essence_name_for_plural_234="модели"
	essence_name_for_plural_others="моделей"
	not_able_for_delete
	without_add
	without_export
	without_details
	emit_on_double_click_element
	v-on:double_click_element="(selected_element) => open(selected_element)"
	v-on:delete_one="refresh_main_tree"
	v-on:delete_many="refresh_main_tree"
>

	<template v-slot:title><h3>Реестр моделей оценки КС</h3></template>
	
	<template v-slot:activities="selected_element">
		
		<b-dropdown-item v-on:click="() => open(selected_element.data)">Открыть</b-dropdown-item>
		<b-dropdown-item v-on:click="() => open(selected_element.data, true)">Открыть в новой вкладке</b-dropdown-item>

	</template>

	<template v-slot:table_cell_params="cell_data">
		<b-button v-if="cell_data.data.field.key == 'settings'" size="sm" @click="() => delete_this(cell_data.data.item)" variant="outline-primary-dark">

			<base-icon name="delete" />

		</b-button>

		<div v-if="cell_data.data.field.key == 'name'">
	
			<b-link href="#" @click="() => open(cell_data.data.item)">{{ cell_data.data.value }}</b-link>

		</div>
		<div v-if="cell_data.data.field.key == 'group_name'">
	
			<router-link :to="'/group_statistic/' + cell_data.data.item.group_id">{{ cell_data.data.value }}</router-link>

		</div>
	</template>

</elements>

</template>

<script>

import api from "../../../api"
import { bus } from "../../../api/bus"
import variables from "../../../api/variables"
import elements from "../../elements"

const service = "cadastral_cost_evaluation"

export default
{
	components :
	{
		elements,
	},

	beforeMount()
	{
		this.attrs = [
			{
				key : "name",
				label : "Наименование",
				type : "str",
				sortable : true,
				visible : true,
				visible_if_no_visible : true,
				in_query : true,
				params : true,
			},
			{
				key : "group_name",
				label : "Наименование оценочной группы/подгруппы",
				type : "str",
				sortable : true,
				visible : true,
				visible_if_no_visible : true,
				in_query : true,
				params : true,
			},
		]

		api.call(this, "cadastral", "get_reference", { reference : "cost_evaluation_approaches" },
			response =>
			{
				var values = []

				response.reference.forEach(value => values.push({ label : value, value : value }))

				this.attrs.push(
					{
						key : "approach",
						label : "Подход",
						type : "str",
						sortable : true,
						visible : true,
						in_query : true,
						reference : { simple_values : values }
					})

				this.ready ++
			})

		api.call(this, "cadastral", "get_reference", { reference : "cost_evaluation_types" },
			response =>
			{
				var values = []

				response.reference.forEach(value => values.push({ label : value, value : value }))

				this.attrs.push(
					{
						key : "type",
						label : "Метод",
						type : "str",
						sortable : true,
						visible : true,
						in_query : true,
						reference : { simple_values : values }
					})

				this.ready ++
			})

		if (this.check_roles([ "group_tree" ]) && !this.$root.not_editable)
		{
			this.attrs.unshift({
				key : "settings",
				label : "",
				visible : true,
				visible_if_no_visible : true,
				params : true,
				thClass: "cell_settings_head",
				tdClass: "cell_settings",
				thStyle: "width: 64px;"
			})
			}

		this.ready ++
	},

	data()
	{
		return {

			service : service,
			attrs : [],
			ready : 0,
    
		}
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		refresh()
		{
			this.$refs.table.refresh()
		},

		get_url(element)
		{
			return '/cost_evaluations/' + element.group_id + '/' + variables.CE_approaches.getCodeByName(element.approach)
		},

		open(element, new_tab = false)
		{
			const active_step_from_storage = api.storage.get(this, `cost_evaluation_${element.group_id}`, null, Object)

			if(new_tab)
			{
				if (
					active_step_from_storage != null
					&& active_step_from_storage.active_step.split("_")[0] !== variables.CE_approaches.getCodeByName(element.approach)
				)
				{
					this.$localStorage.set(this, `cost_evaluation_${element.group_id}`, null)
				}

				window.open(this.get_url(element), "_blank")
			}
			else
			{
				if (
					active_step_from_storage != null
					&& active_step_from_storage.active_step.split("_")[0] !== variables.CE_approaches.getCodeByName(element.approach)
				)
				{
					api.storage.set(this, `cost_evaluation_${element.group_id}`, null)
				}

				this.$router.push(this.get_url(element))
					.catch((e) => {if (e.type != 2) console.error(e)})
			}
		},
		
		delete_this(model)
		{
			this.$bvModal.msgBoxConfirm(
				"При удалении модели оценки КС удалятся расчетные данные у объектов оценки, в том числе Кадастровая стоимость и УПКС. Удалить расчет?",
				{
					title : "Подтверждение удаления",
					okVariant : "danger",
					okTitle : "Да",
					cancelVariant : "outline-primary-secondary",
					cancelTitle : "Нет",
					hideHeaderClose : false,
					centered : true
				})
				.then(
					value =>
					{
						if(value)
							api.call(this, this.service, "delete", { id : model.id }, () => {
								const active_step_from_storage = api.storage.get(this, `cost_evaluation_${model.group_id}`, null, Object)
								if (
									active_step_from_storage
									&& active_step_from_storage.active_step
									&& active_step_from_storage.active_step.startsWith(
										variables.CE_approaches.getCodeByName(model.approach)
									)
								)
								{
									api.storage.set(this, `cost_evaluation_${model.group_id}`, null)
								}

								api.show_notification(this, "Модель оценки КС удалена")
								bus.$emit("update_main_tree")
								this.refresh()
							}
						)
					})
		},

		refresh_main_tree()
		{
			bus.$emit("update_main_tree")
		},
	},
}

</script>

<style scoped>
* >>> .cell_settings_head
{
	text-align: center;
}
</style>

